import PropTypes from 'prop-types';

const ItemList = ({ renderItem, items }) => items.map(renderItem);

ItemList.propTypes = {
  renderItem: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.any),
};

ItemList.defaultProps = {
  renderItem: () => {},
  items: [],
};

export { ItemList };



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/ItemList.js